import { useContext } from "react";
import PermissionsContext from "../contexts/userPermissionContext";

const usePermissions = () => useContext(PermissionsContext);

export default usePermissions;
